/**
 * The `value` function converts between different cryptocurrency units.
 * See `value.spec.ts` for example usage.
 */
import BigNumber from "bignumber.js";
const toBigNumber = (valueIn) => BigNumber.isBigNumber(valueIn)
    ? new BigNumber(valueIn)
    : new BigNumber(valueIn.toString());
export const toSmallestUnit = (value, decimals) => toBigNumber(value)
    .times(new BigNumber(10).exponentiatedBy(decimals))
    .decimalPlaces(0)
    .toFixed();
export const fromSmallestUnit = (value, decimals) => toBigNumber(value)
    .dividedBy(new BigNumber(10).exponentiatedBy(decimals))
    .toFixed();
//# sourceMappingURL=value.js.map